/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface PreviewCarrierEmailRequest
 */
export interface PreviewCarrierEmailRequest {
  /**
   *
   * @type {string}
   * @memberof PreviewCarrierEmailRequest
   */
  messageId: string;
}

/**
 * Check if a given object implements the PreviewCarrierEmailRequest interface.
 */
export function instanceOfPreviewCarrierEmailRequest(
  value: object,
): value is PreviewCarrierEmailRequest {
  if (!("messageId" in value) || value["messageId"] === undefined) return false;
  return true;
}

export function PreviewCarrierEmailRequestFromJSON(
  json: any,
): PreviewCarrierEmailRequest {
  return PreviewCarrierEmailRequestFromJSONTyped(json, false);
}

export function PreviewCarrierEmailRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PreviewCarrierEmailRequest {
  if (json == null) {
    return json;
  }
  return {
    messageId: json["messageId"],
  };
}

export function PreviewCarrierEmailRequestToJSON(
  json: any,
): PreviewCarrierEmailRequest {
  return PreviewCarrierEmailRequestToJSONTyped(json, false);
}

export function PreviewCarrierEmailRequestToJSONTyped(
  value?: PreviewCarrierEmailRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    messageId: value["messageId"],
  };
}
